import React from "react";
import { QuestionTableRedux } from "@learningblocks/simulations/shared-components";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import { Utilities } from "@learningblocks/exp-constants";
const { COMPONENT_TYPE } = Utilities;
import { TranslationWrapper } from "@learningblocks/simulations/shared-components";
import { HighlightProvider as SharedHighlightProvider } from "@learningblocks/shared-components";
import { useHighlight } from "@learningblocks/shared/glossary";
import { Component } from "../index";

export const Content = ({ components }: { components: Component[] }) => {
  const { onPlainTextClick } =
    React.useContext(SharedHighlightProvider.Context) || useHighlight();

  const plainText = (component: Component) => {
    const onClickHighlight = (
      contentId: string,
      event: React.MouseEvent<HTMLDivElement>
    ) => {
      onPlainTextClick(contentId, event);
    };
    return (
      <RichText
        key={component.id}
        onClickHighlight={onClickHighlight}
        {...component}
      />
    );
  };

  const questionTable = (component: Component) => {
    return <QuestionTableRedux key={component.id} {...component} />;
  };

  const renderComponent = (component: Component) => {
    const translatedComponent = TranslationWrapper({ component });
    switch (translatedComponent.type) {
      case COMPONENT_TYPE.PLAIN_TEXT:
        return plainText(translatedComponent);
      case COMPONENT_TYPE.QUESTION_TABLE:
        return questionTable(translatedComponent);

      default:
        return <h3> Component Type {translatedComponent.type}</h3>;
    }
  };

  return <>{components.map((component) => renderComponent(component))}</>;
};
